import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { mapIntentToRequest } from "../../../../service/network/RequestMapper";
import IntentType from "../../../../intentexecutor/utils/IntentType";
import { getApiUrl } from "../../../../service/network/UrlMapper";
import { performPostRequest } from "../../../../service/network/NetworkService";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";

const SelectCarePlanStatus = ({ status, setCarePlan, coordinatorOnly }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    const fetchSourceList = async () => {
      const payload = {
        configurationKey: ["niramaya.volunteer.request.filter.options"],
      };
      const request = mapIntentToRequest(
        IntentType.GET_CONFIGURATION,
        payload,
        {
          organizationIdentifier: organizationIdentifier,
        },
      );
      const urlMapper = getApiUrl();
      const result = await performPostRequest(
        urlMapper[IntentType.GET_CONFIGURATION],
        JSON.stringify(request),
      );
      const response = await result.json();
      const parsedResult =
        response[0].configurationValue &&
        JSON.parse(response[0].configurationValue);

      setStatusList(parsedResult);
    };

    fetchSourceList();
  }, [organizationIdentifier]);

  return (
    <>
      <Select
        onChange={(value) =>
          setCarePlan((prevData) => ({ ...prevData, status: value }))
        }
        options={statusList}
        value={status}
        placeholder="Status"
        style={{
          width: 120,
        }}
        disabled={!coordinatorOnly}
      />
    </>
  );
};

export default SelectCarePlanStatus;
